import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringSeparator'
})
export class StringSeparatorPipe implements PipeTransform {

  transform(s: string): any {
    const sectors = s.split(/(?=[A-Z])/);
    return sectors.join(' ');
  }

}
export function separateString(s: string): string {
  const sectors = s.split(/(?=[A-Z])/);
  return sectors.join(' ');
}
